<template>
        <div class="modal fade" tabindex="-1" role="dialog" :class="onmasive ? 'show' : 'show'" :style="onmasive ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-check-circle"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Facturación masiva</h5>
                            <p>Todavia no se ha escaneado todos los paquetes</p>
                            <small class="d-block text-xs text-muted">¿Realmente desea procesar la solicitud?</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-primary px-3" @click="ACTION()">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Continuar</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default{
    props: ['onmasive', 'count'],
    data(){
        return{
            password: '',
            type: false,
        }
    },
    methods: {
        ACTION: function(){
            this.$emit('onmasive')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/awbs/modals/Masive.vue